import { render, staticRenderFns } from "./UsersTabs.vue?vue&type=template&id=c908bbee&scoped=true"
import script from "./UsersTabs.vue?vue&type=script&lang=js"
export * from "./UsersTabs.vue?vue&type=script&lang=js"
import style0 from "./UsersTabs.vue?vue&type=style&index=0&id=c908bbee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c908bbee",
  null
  
)

export default component.exports